import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ReactTable from "components/lib/Global/ReactTable";
import OrgAdminSubRowAsync from "./SubRowAsync";
import OrganizationsTableActionMenu from "components/lib/Shared/OrganizationsTableActionMenu";
import { useToast } from "hooks/useToast";
import {
  removeOrganization,
  sendInviteNotification,
} from "state/slices/organizations";
import SearchInput from "components/lib/Shared/SearchInput";
import { getCurrentUser } from "state/slices/auth";
import Cookie from "js-cookie";
import { Constants } from "config/constants";
import { useDebounce } from "use-debounce";
import { getCorporates } from "state/slices/contactPersonCorporates";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";

const OrganizationsTable = (props) => {
  const { organizations, currentPage, rowsPerPage, setSearchTerm, searchTerm, setCurrentPage } = props
  const currentTab = "stakeholderTab";
  const { toast } = useToast(5000);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.userSlice);
  const cookieRole = Cookie.get("role");
  const isSuperAdmin = props?.isSuperAdmin || cookieRole === Constants.COOKIE_ROLES.SUPER_ADMIN;



  if (!isSuperAdmin) {
    organizations = organizations.filter(
      (org) => org.role === Constants.ROLES.SYSTEM_ADMIN
    );
    organizations = organizations.map(({ corporate }) => corporate);
  }

  const handleResendInvite = async (row) => {
    try {
      await dispatch(
        sendInviteNotification({
          data: {
            organizationName: row.names.companyName,
            contactPersonEmail: row.identificationDetails.emailAddress,
            corporateId: row._id,
          },
        })
      );
      toast("success", "Invite sent successfully.");
    } catch (error) {
      toast(
        "error",
        error?.message ?? "Something went wrong please try again."
      );
    }
  };

  const handleRemove = async (row) => {
    // Implement remove functionality if needed
    try {
      const res = await dispatch(
        removeOrganization({
          corporateId: row.original._id,
          data: {
            emails: [
              currentUser?.email,
              row.original?.identificationDetails?.emailAddress,
            ],
          },
        })
      );
      await dispatch(getCurrentUser());
      toast("success", "Organization removed successfully.");
    } catch (error) {
      toast(
        "error",
        error?.message ?? "Something went wrong please try again."
      );
    }
  };

  const columns = [
    {
      Header: "Organization",
      className: "p-4 text-ellipsis overflow-hidden max-w-[150px]",
      Cell: ({ row }) => row.original?.names?.companyName ?? "N/A",
    },
    {
      Header: "Type",
      accessor: "partnershipType",
      Cell: ({ row }) => row.original?.partnershipType ?? "N/A",
    },
    {
      Header: "Email",
      accessor: "idType",
      Cell: ({ row }) =>
        row.original?.identificationDetails?.emailAddress ?? "N/A",
    },
    {
      Header: "Contact Person",
      Cell: ({ row }) =>
        row.original?.identificationDetails?.companyContactName ?? "N/A",
    },
    {
      Header: "Status",
      Cell: ({ row }) => row.original?.status ?? "N/A",
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        return (
          <OrganizationsTableActionMenu
            row={row}
            disableResetAccessBtn
            showViewBtn={["Active", "Rejected"].includes(row.original?.status)}
            hideResendInviteBtn={row.original?.status !== "Draft"}
            hideReviewBtn={row.original?.status !== "Review"}
            disableResendInviteBtn={row.original?.status !== "Draft"}
            disableReviewBtn={row.original?.status !== "Review"}
            handleResendInvite={handleResendInvite}
            handleRemove={handleRemove}
          />
        );
      },
    },
  ];

  // Create a function that will render our row sub components
  const renderRowSubComponent = React.useCallback(
    ({ row, rowProps, visibleColumns }) => {
      return (
        <OrgAdminSubRowAsync
          row={row}
          rowProps={rowProps}
          visibleColumns={visibleColumns}
          currentTab={currentTab}
        />
      );
    },
    []
  );

  function handleSearch(e) {
    setSearchTerm(e.target.value);
  }


  return (
    <>
      <div className="flex items-center justify-between my-2">
        <div className="flex items-center space-x-4">
          <h2 className="font-semibold">Filter by:</h2>
        </div>
        <SearchInput value={searchTerm} handleOnChange={handleSearch} />
      </div>
      <div className="w-full bg-white shadow">
        <div className="w-full">
          <ReactTable
            columns={columns}
            data={organizations}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalRows={organizations.length}
            setCurrentPage={setCurrentPage}
            paginate
            renderRowSubComponent={renderRowSubComponent}
          />
        </div>
      </div>
    </>
  );
};

export default OrganizationsTable;
